import './HomeChart.scss'
import React from 'react'
import { Knob } from 'primereact/knob'

const HomeChart = (props: any) => {
  let { labelText, knobValue, name } = props

  if (knobValue == null) knobValue = 0

  return (
    <>
      <div className="home-card-knob d-flex flex-column">
        <label>{labelText}</label>
        <span className={'location-summary'}>{name}</span>
        <Knob
          value={knobValue}
          readOnly
          strokeWidth={5}
          valueColor={knobValue < 34 ? '#CAD3FC' : knobValue < 67 ? '#9DAAEB' : '#5868B8'}
          valueTemplate={'{value}%'}
          size={200}
          textColor={'#363636'}
        />
      </div>
    </>
  )
}

export default HomeChart
